<script setup>
import { useI18n } from 'vue-i18n'
import { PageHeader } from '@drama/ui'

import { scenarioId } from './scenario.js'
import ResourcesTab from './ResourcesTab.vue'
import ScenarioSelect from './ScenarioSelect.vue'

const { t } = useI18n()
</script>

<template>
  <div class="intent-videos-page vga-page" data-insp-path="apps/visual-game-admin/src/pages/intent-video/ResourcesPage.vue">
    <PageHeader :title="t('visualGameAdmin.intentVideo.tabs.resources')">
      <template #subtitle>
        <span>{{ t('visualGameAdmin.intentVideo.subtitle') }}</span>
      </template>
      <template #actions>
        <ScenarioSelect />
      </template>
    </PageHeader>

    <ResourcesTab v-if="scenarioId !== ''" :key="scenarioId" :scenario-id="scenarioId" />
  </div>
</template>
